import React from 'react';
import { LucideIcon } from 'lucide-react';
import { Card, CardContent } from '../../../../components/ui/Card';

type Tone = 'green' | 'amber' | 'red' | 'blue' | 'neutral';

interface ComplianceStatusCardProps {
  icon: LucideIcon;
  label: string;
  value: React.ReactNode;
  subtext?: React.ReactNode;
  tone?: Tone;
}

const toneColors: Record<Tone, { icon: string; value: string }> = {
  green: { icon: 'text-green-500', value: 'text-green-600' },
  amber: { icon: 'text-amber-500', value: 'text-amber-600' },
  red: { icon: 'text-red-500', value: 'text-red-600' },
  blue: { icon: 'text-blue-500', value: 'text-foreground' },
  neutral: { icon: 'text-muted-foreground', value: 'text-foreground' },
};

export const ComplianceStatusCard: React.FC<ComplianceStatusCardProps> = ({
  icon: Icon,
  label,
  value,
  subtext,
  tone = 'neutral',
}) => {
  const colors = toneColors[tone];
  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex items-center gap-2 mb-1">
          <Icon className={`w-4 h-4 ${colors.icon}`} />
          <p className="text-sm text-muted-foreground">{label}</p>
        </div>
        <p className={`text-2xl font-bold ${colors.value}`}>{value}</p>
        {subtext && <p className="text-xs text-muted-foreground mt-0.5">{subtext}</p>}
      </CardContent>
    </Card>
  );
};
